import React from "react";
import { Button, Modal } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import apiProxy from "../../api/apiProxy";
import ButtonWithApiCall from "../ButtonWithApiCall";

const StoreZoneDeleteModal = props => {
  const confirmDeleteOfStoreZone = () => {
    return apiProxy.storeLighting
      .deleteStoreZone(props.storeId, props.zoneId)
      .then(() => {
        props.closeDialog();
        props.onDeleteSuccess();
      });
  };

  return (
    <Modal 
      isOpen={props.open} 
      onClose={props.closeDialog}
      header={{ title: "Are you sure you would like to delete this zone?", as: "h3" }}
    >
      <p>You can't recover this zone once it has been deleted.</p>
      <ButtonWithApiCall
        onClick={confirmDeleteOfStoreZone}
        label="Delete"
        savingMessage="Deleting Store Zone"
        useInlineError
      />
      <Button
        variant="secondary"
        className="fable:ml-8"
        onClick={props.closeDialog}
      >
        Cancel
      </Button>
    </Modal>
  );
};

export default StoreZoneDeleteModal;

StoreZoneDeleteModal.propTypes = {
  storeId: PropTypes.string,
  closeDialog: PropTypes.func,
  zoneName: PropTypes.string,
  zoneId: PropTypes.string,
  onDeleteSuccess: PropTypes.func.isRequired
};
